import React from 'react'
import { withStyles } from '@material-ui/core/styles';
import {Typography, Radio, RadioGroup, FormControlLabel, FormControl, FormLabel} from '@material-ui/core';

const styles = {
  box: {
    display: 'flex',
    flexDirection: 'row'
  },
  label: {
    fontSize: 'small'
  }
}

class SearchModeSelection extends React.Component {
  render () {
    const { classes, value, onChange, disabled } = this.props
    return (
      <FormControl className={classes.box} component="fieldset">
        <RadioGroup aria-label="position" name="position" value={value} onChange={(event) => onChange(event.target.value)} row>
          <FormControlLabel
            value="equalsto"
            control={<Radio disabled={disabled}/>}
            label={<Typography className={classes.label}>Equals to</Typography>}
            labelPlacement="end"
          />
          <FormControlLabel
            value="startswith"
            control={<Radio disabled={disabled}/>}
            label={<Typography className={classes.label}>Starts with</Typography>}
            labelPlacement="end"
          />
          <FormControlLabel
            value="endswith"
            control={<Radio disabled={disabled}/>}
            label={<Typography className={classes.label}>Ends with</Typography>}
            labelPlacement="end"
          />
          <FormControlLabel
            value="contains"
            control={<Radio disabled={disabled}/>}
            label={<Typography className={classes.label}>Contains</Typography>}
            labelPlacement="end"
          />
        </RadioGroup>
      </FormControl>
    );
  }
}

export default withStyles(styles)(SearchModeSelection)
